/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingMetricAccess extends models.BillingMetricAccessBase {
    getFixupPrototypeFunction() { return BillingMetricAccess.fixupPrototype; }

    static newInstance(model: Partial<BillingMetricAccess>): BillingMetricAccess {
        let obj = Object.assign(new BillingMetricAccess(), model);
        BillingMetricAccess.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingMetricAccess>): BillingMetricAccess {
        if (!model) return null;
        return BillingMetricAccess.newInstance(<BillingMetricAccess> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingMetricAccess) {
        if (!obj) return;

        models.BillingMetricAccess.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingMetricAccess): boolean {
        if (models.BillingMetricAccessBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingMetricAccess.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.denied_identities) {
            models.DeniedRolesAndUserGroups.fixupPrototype(this.denied_identities);
        }
    }

    /**
     * The Sys ID of the access assignment
     */
    sys_id: string;

    denied_identities: models.DeniedRolesAndUserGroups;

}
